import { ctConstants } from "./ctConstants";

/*** MOUNT ADOBE ANALYTICS SCRIPT ***/
export function mountAdobeScript() {
  const head = document.getElementsByTagName("head")[0];
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.src = process.env.REACT_APP_ADOBE_ANALYTICS_SCRIPT;
  script.async = true;

  head.appendChild(script);
}

export function mountPaypalScript() {
  const head = document.getElementsByTagName("head")[0];
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.src = "https://www.paypal.com/sdk/js?client-id="+process.env.REACT_APP_PAYPAL_CLIENT_ID;
  script.async = true;
  head.appendChild(script);
}


/*** EVENT17 SUBMIT REVIEW ***/
export function event17_submit_review(rating, source) {
  var ev = {};
  ev.eventInfo = {
    type: ctConstants.trackEvent,
    eventAction: ctConstants.rrRenders,
    eventLabel: `Rating - ${rating} ${source}`,
    eventValue: 1
  };
  ev.category = { primaryCategory: ctConstants.custom };
  ev.attributes = { nonInteractive: { nonInteraction: 1 } };
  ev.subcategory = "Read";
  window.digitalData.event.push(ev);
}

/*** EVENT38 CLICK TO PURCHASE ***/
export function event38_click_to_purchase(
  id,
  name,
  price,
  brand,
  quantity,
  category
) {
  let ev = {};
  window.digitalData.product = [];
  window.digitalData.product.push({
    productInfo: {
      productID: id,
      productName: name,
      price: price,
      brand: brand,
      quantity: quantity
    },
    category: {
      primaryCategory: category
    }
  });
  ev.eventInfo = {
    type: ctConstants.trackEvent,
    eventAction: ctConstants.purchase,
    eventLabel: `Clicked Buy Now - ${name}`,
    eventValue: 1
  };
  ev.category = { primaryCategory: ctConstants.conversion };
  ev.subcategory = "Lead";
  window.digitalData.event.push(ev);
}

/*** EVENT scADD ADD TO CART ***/

export function scAdd_add_to_cart(id, name, price, brand, quantity, category) {
  var ev = {};
  window.digitalData.cart = {};
  window.digitalData.cart.item = [];
  window.digitalData.cart.item.push({
    productInfo: {
      productID: id,
      productName: name,
      price: price,
      brand: brand,
      quantity: quantity
    },
    category: {
      primaryCategory: category
    },
    pCAT: {
      name: "shs",
      level: "2"
    },
    attributes: {
      productVariants: id,
      listPosition: 4
    }
  });
  window.digitalData.component.push({
    componentInfo: {
      componentID: ""
    },
    attributes: {
      position: "",
      listPosition: ""
    }
  });

  window.digitalData.product = [];
  window.digitalData.product.push({
    productInfo: {
      productID: id,
      productName: name,
      price: price,
      brand: brand,
      quantity: quantity
    },
    category: {
      primaryCategory: category
    },
    pCAT: {
      name: "shs",
      level: "2"
    },
    attributes: {
      productVariants: "",
      listPosition: 4
    }
  });
  var ev = {};
  ev.eventInfo = {
    type: ctConstants.addtoCart
  };
  ev.category = { primaryCategory: ctConstants.conversion };
  ev.subcategory = "Lead";
  window.digitalData.event.push(ev);
}

/*** EVENT 44 CLICK MINI CART ICON ***/

export function event44_click_cart_icon() {
  var ev = {};
  ev.eventInfo = {
    type: ctConstants.trackEvent,
    eventAction: ctConstants.miniBag,
    eventLabel: "Open",
    eventValue: 1
  };
  ev.category = { primaryCategory: ctConstants.custom };
  window.digitalData.event.push(ev);
}

/*** EVENT 24 VIEW QUESTION ***/

export function event24_view_question(qns, ans, label) {
  var ev = {};
  window.digitalData.component = [];
  window.digitalData.component.push({
    componentInfo: {
      // 'componentID':componentID,
      componentName: "Hair Diagnostics Quiz"
    },
    attributes: {
      position: "",
      listPosition: "",
      componentVariant: "",
      DTResult: "",
      DTMSARes: "",
      DTQns: qns,
      DTAns: ans
    }
  });
  window.digitalData.component[0].attributes.subattributes = [];
  window.digitalData.component[0].attributes.subattributes.push({
    DTQns: qns,
    DTAns: ans,
    DTQnsID: "",
    DTAnsID: ""
  });
  ev.eventInfo = {
    type: ctConstants.diagtooleve
  };
  ev.category = { primaryCategory: ctConstants.engagement };
  ev.subcategory = "Interest";
  ev.action = ctConstants.diagtoolcta;
  ev.label = label;
  window.digitalData.event.push(ev);
}

/*** EVENT scVIEW VIEW CART ON ATH SITE ***/

export function scView_view_external_cart() {
  var ev = {};
  ev.eventInfo = {
    type: ctConstants.trackEvent,
    eventAction: ctConstants.cartview,
    eventLabel: "View Cart on ATH",
    eventValue: 1
  };
  ev.category = { primaryCategory: ctConstants.custom };
  ev.subcategory = "Lead";
  window.digitalData.event.push(ev);
}

/*** EVENT 27 SUBMIT QUIZ ***/

export function event27_submit_quiz(ath) {
  if (ath === undefined || ath === null) ath = false;
  var ev = {};
  ev.eventInfo = {
    type: ctConstants.trackEvent,
    eventAction: ctConstants.registration,
    eventLabel: !ath ? "Registered" : "Registered (P2)",
    eventValue: 1
  };
  ev.category = { primaryCategory: ctConstants.other };
  window.digitalData.event.push(ev);
}

/*** EVENT 2 PROFILE --> RECOMMENDATIONS ***/
// export function event2_navigate_from_prof_to_reco(url) {
//   var ev = {};
//   ev.eventInfo = {
//     type: ctConstants.trackEvent,
//     eventAction: ctConstants.linkClick,
//     eventLabel: url,
//     eventValue: 1
//   };
//   ev.category = { primaryCategory: ctConstants.custom };
//   window.digitalData.event.push(ev);
// }

/*** EVENT 2 OTHER LINKS ***/
export function event2_click_event(event) {
  var ev = {};
  ev.eventInfo = {
    type: ctConstants.trackEvent,
    eventAction: ctConstants.linkClick,
    eventLabel: event,
    eventValue: 1
  };
  ev.category = { primaryCategory: ctConstants.custom };
  if(window.digitalData) {
    window.digitalData.event.push(ev);
  }
}

/***  EVENT 50 SUCCESSFUL OPT IN ***/

export function event50_opt_in_event(phase) {
  var ev = {};
  ev.eventInfo = {
    type: ctConstants.trackEvent,
    eventAction: ctConstants.Acquisition,
    eventLabel: `Opt In (${phase})`,
    eventValue: 1
  };
  ev.category = { primaryCategory: ctConstants.conversion };
  ev.subcategory = "Lead";
  window.digitalData.event.push(ev);
}



// WEBPACK FOOTER //
// ./src/ath/utils/aaUtils.js